import { render } from "./ProfileModal.vue?vue&type=template&id=c5dcadf6"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"

import "./ProfileModal.vue?vue&type=style&index=0&id=c5dcadf6&lang=css"

import exportComponent from "G:\\workspace\\screened-cv-parser\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__